class DistributionUtil {
  static Options = [
    { label: 'Ignore or None', value: 1 },
    { label: 'If found Add in Existing', value: 2 },
    { label: 'If found Replace in Existing', value: 3 }
  ];
}

export default DistributionUtil;